{
    "EN": {
        "pageHeader": "Please provide details of your most recent educational qualification",
        "infoTooltip": "Approximate dates are acceptable. If you're unsure, please default to the 1st of the month.",
        "otherTestName": "Other Test Name",
        "invalidDate": "Please enter valid date",
        "pastDate": "Please enter past date",
        "startAfterEnd": "Commencement date cannot be after graduation date",
        "endBeforeStart": "Graduation date should be higher than the commencement date",
        "back": "Back",
        "next": "Next",
        "cancel": "Cancel",
        "apply": "Apply",
        "optional": "(Optional)",
        "testDetails": "Test details",
        "validScoreBetween": "Please enter a valid score between",
        "and": "and",
        "onlyNumbersAllowed": "Only numbers are allowed (e.g. 3 or 3.5)",
        "datePlaceholder": "DD/MM/YYYY",
        "institutionPassScore": "What is your institution's overall pass score?",
        "honoursDegree": "Did you receive an honours degree?",
        "yes": "Yes",
        "no": "No",
        "admissionTest": "Admission Test"
    },
    "ID_IND": {
        "pageHeader": "Mohon berikan detail pendidikan terakhir Anda",
        "infoTooltip": "Perkiraan tanggal dapat diterima. Jika Anda tidak yakin, silakan gunakan tanggal 1 bulan tersebut.",
        "otherTestName": "Nama Tes Lain",
        "invalidDate": "Masukkan tanggal yang valid",
        "pastDate": "Masukkan tanggal yang sudah lewat",
        "startAfterEnd": "Tanggal mulai tidak boleh setelah tanggal kelulusan",
        "endBeforeStart": "Tanggal kelulusan harus lebih besar dari tanggal mulai",
        "back": "Kembali",
        "next": "Berikutnya",
        "cancel": "Batal",
        "apply": "Terapkan",
        "optional": "(Opsional)",
        "testDetails": "Detail tes",
        "validScoreBetween": "Masukkan skor yang valid antara",
        "and": "dan",
        "onlyNumbersAllowed": "Hanya angka yang diperbolehkan (contoh: 3 atau 3.5)",
        "datePlaceholder": "DD/MM/YYYY",
        "institutionPassScore": "Berapa nilai kelulusan keseluruhan institusi Anda?",
        "honoursDegree": "Apakah Anda menerima gelar kehormatan?",
        "yes": "Ya",
        "no": "Tidak",
        "admissionTest": "Tes Penerimaan"
    },
    "TH_THA": {
        "pageHeader": "กรุณาระบุวุฒิการศึกษาล่าสุด",
        "infoTooltip": "วันที่โดยประมาณสามารถใช้ได้ หากไม่แน่ใจ กรุณาใช้วันที่ 1 ของเดือน",
        "otherTestName": "ชื่อการสอบอื่น",
        "invalidDate": "กรุณากรอกวันที่ที่ถูกต้อง",
        "pastDate": "กรุณากรอกวันที่ในอดีต",
        "startAfterEnd": "วันที่เริ่มต้นไม่สามารถอยู่หลังวันที่สำเร็จการศึกษา",
        "endBeforeStart": "วันที่สำเร็จการศึกษาต้องมากกว่าวันที่เริ่มต้น",
        "back": "ย้อนกลับ",
        "next": "ถัดไป",
        "cancel": "ยกเลิก",
        "apply": "นำไปใช้",
        "optional": "(ไม่บังคับ)",
        "testDetails": "รายละเอียดการสอบ",
        "validScoreBetween": "กรุณากรอกคะแนนที่ถูกต้องระหว่าง",
        "and": "และ",
        "onlyNumbersAllowed": "อนุญาตเฉพาะตัวเลขเท่านั้น (เช่น 3 หรือ 3.5)",
        "datePlaceholder": "DD/MM/YYYY",
        "institutionPassScore": "คะแนนผ่านโดยรวมของสถาบันของคุณคือเท่าไร?",
        "honoursDegree": "คุณได้รับปริญญาเกียรตินิยมหรือไม่?",
        "yes": "ใช่",
        "no": "ไม่",
        "admissionTest": "การสอบคัดเลือกเข้าศึกษา"
    },
    "KR_KOR": {
        "pageHeader": "최근 학력 정보를 입력해 주세요",
        "infoTooltip": "대략적인 날짜도 괜찮습니다. 확실하지 않으면 해당 월의 1일로 입력해 주세요.",
        "otherTestName": "기타 시험 이름",
        "invalidDate": "유효한 날짜를 입력하세요",
        "pastDate": "과거 날짜를 입력해 주세요",
        "startAfterEnd": "시작일은 졸업일 이후일 수 없습니다",
        "endBeforeStart": "졸업일은 시작일보다 이후여야 합니다",
        "back": "뒤로",
        "next": "다음",
        "cancel": "취소",
        "apply": "적용",
        "optional": "(선택 사항)",
        "testDetails": "시험 세부 정보",
        "validScoreBetween": "유효한 점수를 입력해 주세요. 범위:",
        "and": "~",
        "onlyNumbersAllowed": "숫자만 입력 가능합니다 (예: 3 또는 3.5)",
        "datePlaceholder": "DD/MM/YYYY",
        "institutionPassScore": "귀하의 교육기관의 전체 합격 점수는 얼마입니까?",
        "honoursDegree": "우등 학위를 받으셨습니까?",
        "yes": "예",
        "no": "아니오",
        "admissionTest": "입학 시험"
    },
    "TW_CHI": {
        "pageHeader": "請提供最近學歷資料",
        "infoTooltip": "大約日期即可。如果不確定，請預設為該月的1日。",
        "otherTestName": "其他考試名稱",
        "invalidDate": "請輸入有效日期",
        "pastDate": "請輸入過去的日期",
        "startAfterEnd": "開始日期不能晚於畢業日期",
        "endBeforeStart": "畢業日期應晚於開始日期",
        "back": "返回",
        "next": "下一步",
        "cancel": "取消",
        "apply": "套用",
        "optional": "(選填)",
        "testDetails": "考試詳情",
        "validScoreBetween": "請輸入有效分數，範圍為",
        "and": "至",
        "onlyNumbersAllowed": "僅允許輸入數字（例如 3 或 3.5）",
        "datePlaceholder": "DD/MM/YYYY",
        "institutionPassScore": "您的學校整體及格分數是多少？",
        "honoursDegree": "您是否獲得榮譽學位？",
        "yes": "是",
        "no": "否",
        "admissionTest": "入學考試"
    },
    "HK_CHI": {
        "pageHeader": "請提供最近的學歷資料",
        "infoTooltip": "大約日期即可。如果不確定，請預設為該月的1日。",
        "otherTestName": "其他考試名稱",
        "invalidDate": "請輸入有效日期",
        "pastDate": "請輸入過去的日期",
        "startAfterEnd": "開始日期不能晚於畢業日期",
        "endBeforeStart": "畢業日期應晚於開始日期",
        "back": "返回",
        "next": "下一步",
        "cancel": "取消",
        "apply": "套用",
        "optional": "(選填)",
        "testDetails": "考試詳情",
        "validScoreBetween": "請輸入有效分數，範圍為",
        "and": "至",
        "onlyNumbersAllowed": "僅允許輸入數字（例如 3 或 3.5）",
        "datePlaceholder": "DD/MM/YYYY",
        "institutionPassScore": "您的學校整體及格分數是多少？",
        "honoursDegree": "您是否獲得榮譽學位？",
        "yes": "是",
        "no": "否",
        "admissionTest": "入學考試"
    },
    "HK_ZK": {
        "pageHeader": "请提供您最近的学历信息",
        "infoTooltip": "大约日期即可。如果不确定，请默认为该月的1日。",
        "otherTestName": "其他考试名称",
        "invalidDate": "请输入有效日期",
        "pastDate": "请输入过去的日期",
        "startAfterEnd": "开始日期不能晚于毕业日期",
        "endBeforeStart": "毕业日期应晚于开始日期",
        "back": "返回",
        "next": "下一步",
        "cancel": "取消",
        "apply": "应用",
        "optional": "(可选)",
        "testDetails": "考试详情",
        "validScoreBetween": "请输入有效分数，范围为",
        "and": "至",
        "onlyNumbersAllowed": "仅允许输入数字（例如 3 或 3.5）",
        "datePlaceholder": "DD/MM/YYYY",
        "institutionPassScore": "您的学校整体及格分数是多少？",
        "honoursDegree": "您是否获得荣誉学位？",
        "yes": "是",
        "no": "否",
        "admissionTest": "入学考试"
    }
}
